import {
  deleteVirtualOperatorMessageFailure,
  deleteVirtualOperatorMessageSuccess,
  fetchEnterpriseDataFailure,
  fetchEnterpriseDataSuccess,
  fetchVirtualOperatorAmbrogioCostsFailure,
  fetchVirtualOperatorAmbrogioCostsSuccess,
  fetchVirtualOperatorAmbrogioPbxsFailure,
  fetchVirtualOperatorAmbrogioPbxsSuccess,
  fetchVirtualOperatorChatDetailsFailure,
  fetchVirtualOperatorChatDetailsSuccess,
  fetchVirtualOperatorCostsFailure,
  fetchVirtualOperatorCostsSuccess,
  fetchVirtualOperatorMessagesFailure,
  fetchVirtualOperatorMessagesSuccess,
  fetchVirtualOperatorMonitoringFailure,
  fetchVirtualOperatorMonitoringSuccess,
  fetchVirtualOperatorSettingsFailure,
  fetchVirtualOperatorSettingsSuccess,
  fetchVirtualOperatorStatisticsFailure,
  fetchVirtualOperatorStatisticsSuccess,
  fetchVirtualOperatorUsersFailure,
  fetchVirtualOperatorUsersSuccess,
  saveEnterpriseFestivitiesFailure,
  saveEnterpriseFestivitiesSuccess,
  saveEnterpriseInfoFailure,
  saveEnterpriseInfoSuccess,
  saveEnterpriseMessageFailure,
  saveEnterpriseMessageSuccess,
  saveOpeningFailure,
  saveOpeningSuccess,
  saveVirtualOperatorMessageFailure,
  saveVirtualOperatorMessageSuccess,
  saveVirtualOperatorNoCreditRuleFailure,
  saveVirtualOperatorNoCreditRuleSuccess,
  saveVirtualOperatorOfficeFailure,
  saveVirtualOperatorOfficeSuccess,
  saveVirtualOperatorSettingsClosingFailure,
  saveVirtualOperatorSettingsClosingSuccess,
  saveVirtualOperatorSettingsFestivitiesFailure,
  saveVirtualOperatorSettingsFestivitiesSuccess,
  saveVirtualOperatorTicketSettingsFailure,
  saveVirtualOperatorTicketSettingsSuccess,
  saveVirtualOperatorUserFailure,
  saveVirtualOperatorUserSuccess,
} from './actions';
import api from '../api';
import {
  DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  FETCH_ENTERPRISE_DATA_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST,
  FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST,
  FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST,
  FETCH_VIRTUAL_OPERATOR_USERS_REQUEST,
  SAVE_ENTERPRISE_FESTIVITIES_REQUEST,
  SAVE_ENTERPRISE_INFO_REQUEST,
  SAVE_ENTERPRISE_MESSAGE_REQUEST,
  SAVE_OPENING_REQUEST,
  SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST,
  SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST,
  SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST,
  SAVE_VIRTUAL_OPERATOR_USER_REQUEST,
} from './types';
import { call, put, takeLatest } from 'redux-saga/effects';
import { checkApiError, checkApiResponse } from '../rootSaga';
import { fetchPbxQueuesRequest } from '../phone/actions';
import { getInterlocutorData } from '../phone/sagas';

export function* fetchEnterpriseData(action) {
  try {
    const res = yield call(
      api.virtualOperator.getEnterpriseData,
      action.params
    );
    yield call(checkApiResponse, res);
    yield put(fetchEnterpriseDataSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchEnterpriseDataFailure(error));
  }
}

export function* saveEnterpriseMessage(action) {
  try {
    const res = yield call(
      api.virtualOperator.saveEnterpriseMessage,
      action.data
    );
    yield call(checkApiResponse, res);
    yield put(saveEnterpriseMessageSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveEnterpriseMessageFailure(error));
  }
}

export function* saveEnterpriseFestivities(action) {
  try {
    const res = yield call(
      api.virtualOperator.saveEnterpriseFestivities,
      action.data
    );
    yield call(checkApiResponse, res);
    yield put(saveEnterpriseFestivitiesSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveEnterpriseFestivitiesFailure(error));
  }
}

export function* saveEnterpriseInfo(action) {
  try {
    const res = yield call(api.virtualOperator.saveEnterpriseInfo, action.data);
    yield call(checkApiResponse, res);
    yield put(saveEnterpriseInfoSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveEnterpriseInfoFailure(error));
  }
}

export function* saveOpening(action) {
  try {
    const res = yield call(api.virtualOperator.saveOpening, action.data);
    yield call(checkApiResponse, res);
    yield put(saveOpeningSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveOpeningFailure(error));
  }
}

export function* fetchUsers(action) {
  try {
    const res = yield call(api.virtualOperator.getUsers, action.params);
    yield call(checkApiResponse, res);
    if (res.status === 204) {
      yield put(
        fetchVirtualOperatorUsersSuccess({
          users: [],
          total: 0,
        })
      );
    } else {
      yield put(
        fetchVirtualOperatorUsersSuccess({
          users: res.data.data,
          total: res.data.total,
        })
      );
    }
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorUsersFailure(error));
  }
}

export function* saveUser(action) {
  try {
    const res = yield call(api.virtualOperator.saveUser, action.data);
    yield call(checkApiResponse, res);
    yield put(saveVirtualOperatorUserSuccess({ ...action.data, ...res.data }));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorUserFailure(error));
  }
}

export function* saveOffice(action) {
  try {
    if (action.data.id) {
      const res = yield call(api.virtualOperator.editOffice, action.data);
      yield call(checkApiResponse, res);
      yield put(saveVirtualOperatorOfficeSuccess(action.data));
    } else {
      const res = yield call(api.virtualOperator.insertOffice, action.data);
      yield call(checkApiResponse, res);
      yield put(
        saveVirtualOperatorOfficeSuccess({
          id: res.data.id,
          data: action.data.data,
        })
      );
    }
    yield put(fetchPbxQueuesRequest());
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorOfficeFailure(error));
  }
}

export function* fetchMessages(action) {
  try {
    const res = yield call(api.virtualOperator.getMessages, action.params);
    yield call(checkApiResponse, res);
    if (res.status === 204) {
      yield put(
        fetchVirtualOperatorMessagesSuccess({
          messages: [],
          total: 0,
        })
      );
    } else {
      yield put(
        fetchVirtualOperatorMessagesSuccess({
          messages: res.data.data,
          total: res.data.total,
        })
      );
    }
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorMessagesFailure(error));
  }
}

export function* saveMessage(action) {
  try {
    if (action.data.id) {
      const res = yield call(api.virtualOperator.editMessage, action.data);
      yield call(checkApiResponse, res);
      yield put(saveVirtualOperatorMessageSuccess(action.data));
    } else {
      const res = yield call(api.virtualOperator.insertMessage, action.data);
      yield call(checkApiResponse, res);
      yield put(
        saveVirtualOperatorMessageSuccess({
          id: res.data.id,
          data: action.data.data,
        })
      );
    }
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorMessageFailure(error));
  }
}

export function* deleteMessage(action) {
  try {
    const res = yield call(api.virtualOperator.deleteMessage, action.id);
    yield call(checkApiResponse, res);
    yield put(deleteVirtualOperatorMessageSuccess(action.id));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(deleteVirtualOperatorMessageFailure(error));
  }
}

export function* fetchVirtualOperatorSettings() {
  try {
    const res = yield call(api.virtualOperator.getSettings);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorSettingsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorSettingsFailure(error));
  }
}

export function* saveSettingsFestivities(action) {
  try {
    const res = yield call(
      api.virtualOperator.saveFestivitySettings,
      action.data
    );
    yield call(checkApiResponse, res);
    yield put(saveVirtualOperatorSettingsFestivitiesSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorSettingsFestivitiesFailure(error));
  }
}

export function* saveSettingsClosing(action) {
  try {
    const res = yield call(
      api.virtualOperator.saveClosingSettings,
      action.data
    );
    yield call(checkApiResponse, res);
    yield put(saveVirtualOperatorSettingsClosingSuccess(action.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorSettingsClosingFailure(error));
  }
}

export function* fetchStatistics(action) {
  try {
    const res = yield call(api.virtualOperator.getStatistics, action.params);
    yield call(checkApiResponse, res);
    if (res.status === 204) {
      yield put(
        fetchVirtualOperatorStatisticsSuccess({
          statistics: [],
          total: 0,
        })
      );
    } else {
      const interlocutors = res.data.data.map((statisticItem) =>
        call(getInterlocutorData, statisticItem.contactNumber, false)
      );
      for (let i = 0; i < interlocutors.length; i += 1) {
        const response = yield interlocutors[i];
        res.data.data[i].interlocutor = response;
      }
      yield put(
        fetchVirtualOperatorStatisticsSuccess({
          statistics: res.data.data,
          total: res.data.total,
        })
      );
    }
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorStatisticsFailure(error));
  }
}

export function* fetchChatDetails(action) {
  try {
    const res = yield call(api.virtualOperator.getChatDetails, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorChatDetailsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorChatDetailsFailure(error));
  }
}

export function* fetchMonitoring(action) {
  try {
    const res = yield call(api.virtualOperator.getMonitoring, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorMonitoringSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorMonitoringFailure(error));
  }
}

export function* fetchCosts(action) {
  try {
    const res = yield call(api.virtualOperator.getCosts, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorCostsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorCostsFailure(error));
  }
}

export function* fetchAmbrogioCosts(action) {
  try {
    const res = yield call(api.virtualOperator.getAmbrogioCosts, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorAmbrogioCostsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorAmbrogioCostsFailure(error));
  }
}

export function* fetchAmbrogioPbxs(action) {
  try {
    const res = yield call(api.virtualOperator.getAmbrogioPbxs, action.params);
    yield call(checkApiResponse, res);
    yield put(fetchVirtualOperatorAmbrogioPbxsSuccess(res.data));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(fetchVirtualOperatorAmbrogioPbxsFailure(error));
  }
}

export function* saveNoCreditRule(action) {
  try {
    const res = yield call(api.virtualOperator.saveNoCreditRule, action.params);
    yield call(checkApiResponse, res);
    yield put(saveVirtualOperatorNoCreditRuleSuccess(action.params));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorNoCreditRuleFailure(error));
  }
}

export function* saveTicketSettings(action) {
  try {
    const res = yield call(api.virtualOperator.saveTicketSettings, action.params);
    yield call(checkApiResponse, res);
    yield put(saveVirtualOperatorTicketSettingsSuccess(action.params));
  } catch (err) {
    const error = yield call(checkApiError, err);
    if (error) yield put(saveVirtualOperatorTicketSettingsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeLatest(FETCH_ENTERPRISE_DATA_REQUEST, fetchEnterpriseData);
  yield takeLatest(SAVE_ENTERPRISE_MESSAGE_REQUEST, saveEnterpriseMessage);
  yield takeLatest(
    SAVE_ENTERPRISE_FESTIVITIES_REQUEST,
    saveEnterpriseFestivities
  );
  yield takeLatest(SAVE_OPENING_REQUEST, saveOpening);
  yield takeLatest(FETCH_VIRTUAL_OPERATOR_USERS_REQUEST, fetchUsers);
  yield takeLatest(SAVE_VIRTUAL_OPERATOR_USER_REQUEST, saveUser);
  yield takeLatest(SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST, saveOffice);
  yield takeLatest(FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST, fetchMessages);
  yield takeLatest(SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST, saveMessage);
  yield takeLatest(DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST, deleteMessage);
  yield takeLatest(SAVE_ENTERPRISE_INFO_REQUEST, saveEnterpriseInfo);
  yield takeLatest(
    FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST,
    fetchVirtualOperatorSettings
  );
  yield takeLatest(
    SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST,
    saveSettingsFestivities
  );
  yield takeLatest(
    SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST,
    saveSettingsClosing
  );
  yield takeLatest(FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST, fetchStatistics);
  yield takeLatest(
    FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST,
    fetchChatDetails
  );
  yield takeLatest(FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST, fetchMonitoring);
  yield takeLatest(FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST, fetchCosts);
  yield takeLatest(
    FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST,
    fetchAmbrogioCosts
  );
  yield takeLatest(
    FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST,
    fetchAmbrogioPbxs
  );
  yield takeLatest(
    SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST,
    saveNoCreditRule
  );
  yield takeLatest(SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST, saveTicketSettings);
}
